import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewChild } from '@angular/core';
import Jessibuca from 'jessibuca-js';

@Component({
  selector: 'nc-video-flv',
  templateUrl: './video-flv.component.html',
  styleUrls: ['./video-flv.component.less']
})
export class VideoFlvComponent implements AfterViewInit, OnDestroy, OnChanges {
  @ViewChild('videoContainer') videoContainer!: ElementRef<HTMLInputElement>;
  private jessibuca!: Jessibuca;
  playError: boolean = false;
  playTimeout: boolean = false;

  /** 返回Jessibuca */
  @Output() ncLoaded = new EventEmitter<Jessibuca>();
  /** 返回播放状态 */
  @Output() ncPlaying = new EventEmitter<boolean>();

  /** 视频地址 */
  @Input() ncUrl: string = '';
  /** 超时 */
  @Input() ncTimeout: number = 8;
  /** 加载中文案 */
  @Input() ncLoadingText: string = '加载中...';
  /** 播放失败文案 */
  @Input() ncErrorText: string = '播放失败';
  /** 播放超时文案 */
  @Input() ncTimeoutText: string = '播放超时，视频源无响应';
  /** 静音 */
  private _muted: boolean = true;
  @Input() set ncMuted(value: boolean | string) {
    this._muted = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  get ncMuted(): boolean {
    return this._muted;
  }
  /** 自动播放 */
  private _autoplay: boolean = false;
  @Input() set ncAutoplay(value: boolean | string) {
    this._autoplay = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  get ncAutoplay(): boolean {
    return this._autoplay;
  }
  /** 铺满 */
  private _fill: boolean = false;
  @Input() set ncFill(value: boolean | string) {
    this._fill = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  get ncFill(): boolean {
    return this._fill;
  }
  /** 截图 */
  private _screenshot: boolean = false;
  @Input() set ncScreenshot(value: boolean | string) {
    this._screenshot = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  get ncScreenshot(): boolean {
    return this._screenshot;
  }
  /** 录屏 */
  private _record: boolean = false;
  @Input() set ncRecord(value: boolean | string) {
    this._record = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  get ncRecord(): boolean {
    return this._record;
  }
  /** 网速 */
  private _bandwidth: boolean = false;
  @Input() set ncBandwidth(value: boolean | string) {
    this._bandwidth = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  get ncBandwidth(): boolean {
    return this._bandwidth;
  }
  /** 隐藏控制栏 */
  private _controls: boolean = true;
  @Input() set ncControls(value: boolean | string) {
    this._controls = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  get ncControls(): boolean {
    return this._controls;
  }


  constructor() { }

  ngOnDestroy(): void {
    this.destroy();
  }

  ngAfterViewInit(): void {
    if (this.ncUrl) {
      this.init();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['ncUrl'] && changes['ncUrl'].currentValue && !changes['ncUrl'].firstChange) {
      this.init();
    }
  }

  init() {
    this.destroy();
    this.playError = false;
    this.playTimeout = false;
    //这里加延迟是因为destroy后直接重新new的话会报Jessibuca container has been created and can not be created again
    setTimeout(() => {
      this.jessibuca = new Jessibuca({
        url: this.ncUrl,
        decoder: 'assets/jessibuca-js/decoder.js',
        container: this.videoContainer.nativeElement,
        videoBuffer: 0.2,//缓存时长
        isResize: !this.ncFill,//false:视频画面完全填充canvas区域,画面会被拉伸;true:视频画面做等比缩放后,高或宽对齐canvas区域,画面不被拉伸,但有黑边
        loadingText: this.ncLoadingText,//加载过程中文案
        debug: false,
        timeout: this.ncTimeout,
        showBandwidth: this.ncBandwidth,//显示网速
        operateBtns: {
          fullscreen: true,//全屏按钮
          screenshot: this.ncScreenshot,//截图按钮
          play: true,//播放暂停按钮
          audio: true,//声音按钮
          record: this.ncRecord//录制按钮
        },
        isNotMute: false,//是否开启声音
        controlAutoHide: true//自动隐藏控制栏
      });

      if (!this.ncControls) {
        const controls = this.videoContainer.nativeElement.querySelector('.jessibuca-controls');
        controls?.remove();
      }

      //错误监听
      this.jessibuca.on("error", (error) => {
        console.error('error:', error);
        this.playError = true;
      })

      //超时监听
      this.jessibuca.on("timeout", (error) => {
        console.error('timeout:', error);
        this.playTimeout = true;
      })

      //播放监听
      this.jessibuca.on("play", () => {
        this.ncPlaying.emit(true);
      });

      //暂停监听
      this.jessibuca.on("pause", () => {
        this.ncPlaying.emit(false);
      });

      this.jessibuca.on("load", () => {
        //自动播放
        if (this.ncAutoplay) {
          this.jessibuca.play();
        }
        //开启声音
        if (!this.ncMuted) {
          this.jessibuca.cancelMute();
        }
        //返回对象
        this.ncLoaded.emit(this.jessibuca);
      });
    }, 100)
  }

  destroy() {
    if (this.jessibuca) {
      this.jessibuca.destroy();
    }
  }
}
